import store from '../../../../store';
import { createGroupsService } from './GroupsService.impl';

export const myGroupsService = createGroupsService(store);
